import React from "react";
import styles from "./content.module.scss";
import { Route, Switch } from "react-router";
import LogisticsBar from "../sections/sideBars/LogisticsBar";
import ControlPoints from "../Logistics/ControlPoints/ControlPoints";
import Routes from "../Logistics/Routes/Routes";
import Trips from "../Logistics/Trips/Trips";
import TripUnitsBar from "../Logistics/TripUnitsBar/TripUnitsBar";
import LogisticReports from "../Logistics/LogisticReports/LogisticReports";
import MonitoringsTaskTripsBar from "../Logistics/Monitorings/MonitoringsTaskTripsBar/MonitoringsTaskTripsBar";
import MonitoringTaskTripsMapLastState from "../Logistics/Monitorings/LastStateMap/MonitoringTaskTripsMapLastState";
import UnitsTaskTripMap from "../Logistics/Monitorings/UnitsTaskTripMap/UnitsTaskTripMap";
import MonitoringTripUnitsBar from "../Logistics/Monitorings/MonitoringTaskTripUnitsBar/MonitoringTripUnitsBar";
import TaskTripSettings from "../Logistics/Monitorings/TaskTrip/TaskTripSettings";

const LogisticsContent = (props) => {
  return (
    <div>
      <Switch>
        <Route
          exact
          path={[
            "/logistic",
            "/logistic/controlPoints",
            "/logistic/routes",
            "/logistic/routes/:id",
            "/logistic/trips",
            "/logistic/trips/:id",
            "/logistic/reports",
            "/logistic/reports/:id",
            "/logistic/monitorings",
            "/logistic/monitorings/:id",
            "/logistic/monitorings/:id/settings",
          ]}
        >
          <div className={props.isSideBarOpen ? styles.content : styles.content_closedBar}>
            <div className={styles.container_sideBar}>
              <Switch>
                <Route
                  exact
                  path={[
                    "/logistic",
                    "/logistic/controlPoints",
                    "/logistic/routes",
                    "/logistic/routes/:id",
                    "/logistic/trips",
                    "/logistic/reports",
                    "/logistic/reports/:id",
                  ]}
                  component={LogisticsBar}
                />
                <Route exact path={["/logistic/monitorings", "/logistic/monitorings/:id"]} component={MonitoringsTaskTripsBar} />
                <Route exact path={["/logistic/trips/:id"]} component={TripUnitsBar} />
                <Route exact path={["/logistic/monitorings/:id/settings"]} component={MonitoringTripUnitsBar} />
              </Switch>
            </div>
            <div className={styles.container_sideContent}>
              <Switch>
                <Route exact path={["/logistic/controlPoints"]} component={ControlPoints} />
                <Route exact path={["/logistic/routes", "/logistic/routes/:id"]} component={Routes} />
                <Route exact path={["/logistic/trips", "/logistic/trips/:id"]} component={Trips} />
                <Route exact path={["/logistic/reports", "/logistic/reports/:id"]} component={LogisticReports} />
                <Route exact path={["/logistic/monitorings"]} component={MonitoringTaskTripsMapLastState} />
                <Route exact path={["/logistic/monitorings/:id"]} component={UnitsTaskTripMap} />
                <Route exact path={["/logistic/monitorings/:id/settings"]} component={TaskTripSettings} />
              </Switch>
            </div>
          </div>
        </Route>
      </Switch>
    </div>
  );
};

export default React.memo(LogisticsContent);
